<template>
	<AppLayout
		:title="request.lemma !== null ? `${trans('general.quotes.open')}${request.lemma}${trans('general.quotes.close')}` : request.name"
		:return-url="route('events.requests.index')"
		:return-label="trans('admin.periods.events.requests.title')"
	>
		<CardGrid>
			<Card :title="request.location.name" :subtitle="`${dayjs(request.begins_on).format(trans('general.dayjs.date'))} - ${dayjs(request.ends_on).format(trans('general.dayjs.date'))}`">
				<template #badges>
					<Badge v-if="request.online" :color="Color.Purple" active>{{ trans('admin.periods.events.requests.online') }}</Badge>
					<Badge v-else :color="Color.Purple">{{ trans('admin.periods.events.requests.in_person') }}</Badge>
					<Badge :color="Color.Indigo" active>{{ trans(`events.${request.type}.title`) }}</Badge>
				</template>
				<LabeledObject>
					<template #label>{{ trans('admin.periods.events.requests.colleges') }}</template>
					<ol class="list-decimal list-outside ml-5">
						<li v-for="college in request.colleges">{{ college.name }}</li>
					</ol>
				</LabeledObject>
				<LabeledObject>
					<template #label>{{ trans('admin.periods.events.requests.email') }}</template>
					<a class="link" :href="`mailto:${request.email}`">{{ request.email }}</a>
				</LabeledObject>
				<LabeledObject>
					<template #label>{{ trans('admin.periods.events.requests.estimated_participants') }}</template>
					<p>{{ request.estimated_participants }}</p>
				</LabeledObject>
				<LabeledObject v-if="request.observations">
					<template #label>{{ trans('admin.periods.events.requests.observations') }}</template>
					<p>{{ request.observations }}</p>
				</LabeledObject>
				<template v-if="request.is_pending" #footer>
					<SecondaryButton :color="Color.Green" @click.stop="accept">
						<i class="fa-solid fa-check mr-2"/>
						{{ trans('admin.periods.requests.actions.accept') }}
					</SecondaryButton>
					<SoftButton :color="Color.Red" @click.stop="reject">
						<i class="fa-solid fa-ban mr-2"/>
						{{ trans('admin.periods.requests.actions.reject') }}
					</SoftButton>
				</template>
			</Card>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Card from '@/Components/UI/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Badge from '@/Components/UI/Badges/Badge.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import SoftButton from '@/Components/UI/Buttons/SoftButton.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'
import {type EventRequest} from '@/Types/Periods/Events/EventRequest'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'

const props = defineProps<{
	request:EventRequest,
}>()

const working:Ref<boolean> = ref(false)
const request:Ref<EventRequest> = ref(props.request)

function accept():void{
	if(!working.value && confirm(trans('general.confirm_action'))){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('events.requests.update', request.value.id), {
			action: 'accept',
		}).then(({data}:{ data:EventRequest }) => {
			showSuccess(trans('general.updated'))
			request.value = data
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}

function reject():void{
	if(!working.value && confirm(trans('general.confirm_action'))){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('events.requests.update', request.value.id), {
			action: 'reject',
		}).then(({data}:{ data:EventRequest }) => {
			showSuccess(trans('general.updated'))
			request.value = data
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>